import React from 'react';
import NextLink from 'next/link';
import { Box, Button, Container, Typography, Stack, useTheme, alpha } from '@mui/material';
import { Home, Search } from '@mui/icons-material';
import NoSeo from '../shared/custom/no-seo-component';
import { Rutas } from '@/constants/rutas';
import LottieIconComponent, { LOTTIE_ICONS } from '@/DesignSystem/features/lottie/LottieIconComponent';
import Placement1Component from '../ads-components/placements/placement1';

const Custom404Client = () => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'grid',
                placeItems: 'center',
                minHeight: '60vh',
            }}
        >
            <NoSeo />
            <Container maxWidth="sm" sx={{ textAlign: 'center' }}>
                {/* Ilustración SVG ligera (inlined, sin peso de red) */}
                <LottieIconComponent icon={LOTTIE_ICONS.OFFSIDE} width={200} height={200} />

                <Typography
                    variant="h2"
                    component="h1"
                    fontWeight={800}
                    gutterBottom
                    sx={{
                        background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                        backgroundClip: 'text',
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent',
                        mb: 2,
                        textAlign: 'center',
                    }}
                >
                    ¡Fuera de juego!
                </Typography>

                <Typography component="p" gutterBottom color="text.secondary" sx={{ mb: 2 }}>
                    El equipo tiró la línea defensiva muy adelantada y quedaste fuera de juego. No te
                    preocupes, hay tiempo extra y aún puedes marcar.
                </Typography>

                <Stack
                    direction={{ xs: 'column', sm: 'row' }}
                    spacing={2}
                    justifyContent="center"
                    sx={{ mb: 1 }}
                >
                    <Button
                        component={NextLink}
                        href="/"
                        variant="contained"
                        size="large"
                        startIcon={<Home />}
                        sx={{
                            minWidth: '160px',
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        Volver al inicio
                    </Button>
                    <Button
                        component={NextLink}
                        href={Rutas.BUSCADOR_DE_JUGADORES}
                        variant="outlined"
                        size="large"
                        startIcon={<Search />}
                        sx={{
                            minWidth: '160px',
                            borderRadius: 2,
                            textTransform: 'none',
                            fontWeight: 600,
                        }}
                    >
                        Buscar jugadores
                    </Button>
                </Stack>

                <Placement1Component />

                {/* Enlaces de ayuda adicionales */}
                <Box sx={{ mt: 1, pt: 1, borderTop: `1px solid ${alpha(theme.palette.divider, 0.1)}` }}>
                    <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                        ¿Necesitas ayuda? Prueba estos enlaces:
                    </Typography>
                    <Stack direction="row" spacing={3} justifyContent="center" flexWrap="wrap">
                        <Button
                            component={NextLink}
                            href={Rutas.MEJORES_RACHAS}
                            variant="text"
                            size="small"
                            sx={{ textTransform: 'none' }}
                        >
                            Mejores Rachas
                        </Button>
                        <Button
                            component={NextLink}
                            href={Rutas.MERCADO}
                            variant="text"
                            size="small"
                            sx={{ textTransform: 'none' }}
                        >
                            Mercado
                        </Button>
                        <Button
                            component={NextLink}
                            href={Rutas.ALINEACIONES_PROBABLES}
                            variant="text"
                            size="small"
                            sx={{ textTransform: 'none' }}
                        >
                            Alineaciones Probables
                        </Button>
                    </Stack>
                </Box>
            </Container>
        </Box>
    );
};

export default Custom404Client;
